module.exports = __webpack_public_path__ + "static/media/20S.0307d2a5.jpg";